import React from 'react';

export default function SettingsSkeleton() {
  return (
    <div className="settings-page" aria-busy="true" aria-label="Loading configuration">
      <div className="settings-page__header settings-skeleton settings-skeleton--header" />
      {[1, 2, 3].map((i) => (
        <div key={i} className="settings-card settings-skeleton settings-skeleton--card" />
      ))}
    </div>
  );
}
